import React from 'react';
import * as sharedPayStubModalStyles from '../../document-wizard-modal.styles';
import * as fileUploadStyles from './document-select.styles';
import DocumentSelectBase from './document-select-base';
import DocumentSelectPaystubs from './document-select-paystubs';

const sc = { ...sharedPayStubModalStyles, ...fileUploadStyles };

const getDocumentSelect = props => {
  const { wizardConfig } = props;

  switch (wizardConfig.verificationType) {
    case 'payStub':
      return <DocumentSelectPaystubs {...props} />;
    default:
      return <DocumentSelectBase {...props} />;
  }
};

const DocumentSelect = props => {
  return (
    <sc.DocumentSelectWrapper>
      {getDocumentSelect(props)}
    </sc.DocumentSelectWrapper>
  );
};

export default DocumentSelect;
